import { Reveal, MaskedText } from "@/components/motion/Reveal";
import Reel from "@/components/Reel";
import { MORE_REELS } from "@/data/media";
import { LOCATION } from "@/data/content";

export default function Reels() {
  return (
    <>
      <section data-testid="reels-hero" className="px-6 pb-4 pt-36 md:px-12 md:pt-44">
        <div className="mx-auto max-w-[1400px]">
          <Reveal>
            <p className="overline mb-8 text-muted">(Social)</p>
          </Reveal>
          <MaskedText
            lines={["Social Media", "Videos"]}
            delay={0.1}
            className="font-display text-[11vw] font-extralight leading-[0.92] tracking-tight text-ink lg:text-[7vw]"
          />
          <Reveal delay={0.3}>
            <p className="mt-10 max-w-md font-body text-sm leading-relaxed text-stone">
              The wider archive of short-form and social work made in {LOCATION} — motion,
              form and collaboration, reel after reel.
            </p>
          </Reveal>
        </div>
      </section>

      <section data-testid="reels-grid" className="px-6 py-20 md:px-12 md:py-28">
        <div className="mx-auto grid max-w-[1400px] grid-cols-2 gap-4 md:grid-cols-3 md:gap-8">
          {MORE_REELS.map((r, i) => (
            <Reel
              key={r.id}
              {...r}
              index={i + 1}
              label="Reel"
              ratio="aspect-[3/4]"
              className={i % 3 === 1 ? "md:mt-10" : i % 3 === 2 ? "md:mt-5" : ""}
            />
          ))}
        </div>
      </section>
    </>
  );
}
